'use strict';

//---------------------------------------------------------//
//clip-reveal-animation
//---------------------------------------------------------//
(function(global) {
	'use strict';

	var gsap = global.gsap || global.GSAP;
	var ScrollTrigger = global.ScrollTrigger;

	var defaultOptions = {
	/** アニメーションを付与する親要素のセレクター */
	triggerSelector: '.js-clipReveal',
	/** 親要素内のオーバーレイ要素のセレクター（省略時はオーバーレイアニメーションなし） */
	overlaySelector: '.js-clipRevealOverlay',
	/** ScrollTrigger の start 値（要素のどの位置で発火するか） */
	start: 'top bottom',
	/** ScrollTrigger の toggleActions */
	toggleActions: 'play none none reverse',
	/** 一度だけ再生するか */
	once: true,
	/** clip-path アニメーションの時間（秒） */
	duration: 1,
	/** clip-path のイージング */
	ease: 'power4.inOut',
	/** オーバーレイアニメーションの clip 開始からの遅延（秒） */
	overlayDelay: 0.35,
	/** オーバーレイアニメーションの時間（秒） */
	overlayDuration: 1,
	/** オーバーレイアニメーション終了後に DOM から削除するか */
	removeOverlayOnComplete: true,
	/** ScrollTrigger のスクロール要素（Lenis 時は document.documentElement を渡す） */
	scroller: null
	};

	/**
	 * クリップリビールアニメーションを初期化する
	 * @param {Object} options - 上記 defaultOptions で上書き可能
	 * @returns {boolean} 初期化に成功したか（gsap/ScrollTrigger がないと false）
	 */
	function initClipRevealAnimation(options) {
	if (!gsap || !ScrollTrigger) {
		if (typeof console !== 'undefined' && console.warn) {
		console.warn('clip-reveal-animation: gsap と ScrollTrigger を先に読み込んでください。');
		}
		return false;
	}

	gsap.registerPlugin(ScrollTrigger);

	var opts = {};
	for (var key in defaultOptions) {
		opts[key] = (options && options[key] !== undefined) ? options[key] : defaultOptions[key];
	}

	var triggers = document.querySelectorAll(opts.triggerSelector);
	if (!triggers.length) return true;

	var clipHidden = 'polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)';
	var clipVisible = 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)';

	triggers.forEach(function(el) {
		gsap.set(el, { clipPath: clipHidden });

		var overlay = opts.overlaySelector ? el.querySelector(opts.overlaySelector) : null;
		var scrollTriggerConfig = {
			trigger: el,
			start: opts.start,
			toggleActions: opts.toggleActions,
			once: opts.once
		};
		if (opts.scroller) scrollTriggerConfig.scroller = opts.scroller;
		var tl = gsap.timeline({
		scrollTrigger: scrollTriggerConfig
		});

		tl.fromTo(el, { clipPath: clipHidden }, {
		clipPath: clipVisible,
		duration: opts.duration,
		ease: opts.ease,
		onComplete: function() {
			el.style.removeProperty('clip-path');
		}
		});

		if (overlay) {
		tl.fromTo(overlay, { bottom: 0 }, {
			bottom: '100%',
			duration: opts.overlayDuration,
			ease: opts.ease,
			onComplete: opts.removeOverlayOnComplete ? function() {
			if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
			} : undefined
		}, '<+=' + opts.overlayDelay);
		}
	});

	return true;
	}

	global.initClipRevealAnimation = initClipRevealAnimation;
})(typeof window !== 'undefined' ? window : this);


//---------------------------------------------------------//
// Lenis スムーススクロール（767px 以下はオフ。window.locoScroll は後方互換ラッパ）
//---------------------------------------------------------//
var locoScroll;
var locoViewportActive = null;
var lenisCore = null;
var lenisGsapRafCb = null;
var lenisNativeRafId = null;

function locomotiveShouldRun() {
	return window.innerWidth > 767;
}

/** Locomotive の data-scroll 入場クラス（is-inview）を IntersectionObserver で代替 */
function initDataScrollInviewPolyfill() {
	if (!('IntersectionObserver' in window)) return;
	var nodes = document.querySelectorAll('[data-scroll]');
	if (!nodes.length) return;
	var io = new IntersectionObserver(function(entries) {
		for (var i = 0; i < entries.length; i++) {
			var en = entries[i];
			if (!en.isIntersecting) continue;
			var el = en.target;
			var cls = el.getAttribute('data-scroll-class') || 'is-inview';
			el.classList.add(cls);
		}
	}, { root: null, rootMargin: '0px 0px -5% 0px', threshold: 0 });
	for (var j = 0; j < nodes.length; j++) io.observe(nodes[j]);
}

function createLocoCompat(lenis) {
	return {
		_lenis: lenis,
		scrollTo: function(target, opts) {
			if (typeof target === 'number') {
				try { lenis.scrollTo(target, { immediate: true }); } catch (e0) {}
				return;
			}
			opts = opts || {};
			var o = { duration: (opts.duration != null ? opts.duration : 900) / 1000 };
			if (opts.offset != null) o.offset = opts.offset;
			try { lenis.scrollTo(target, o); } catch (e1) {}
		},
		update: function() {
			lenis.resize();
		},
		on: function(ev, fn) {
			if (ev !== 'scroll' || typeof fn !== 'function') return;
			lenis.on('scroll', function() {
				fn({ scroll: { y: lenis.scroll } });
			});
		},
		stop: function() { lenis.stop(); },
		start: function() { lenis.start(); },
		get scroll() {
			return { y: lenis.scroll };
		}
	};
}

function lenisNativeRafLoop(time) {
	if (!lenisCore) return;
	lenisCore.raf(time);
	lenisNativeRafId = requestAnimationFrame(lenisNativeRafLoop);
}

function destroyLocomotiveForViewport() {
	var scrollRoot = document.documentElement;
	if (lenisGsapRafCb && typeof window.gsap !== 'undefined' && window.gsap.ticker) {
		try { window.gsap.ticker.remove(lenisGsapRafCb); } catch (e0) {}
	}
	lenisGsapRafCb = null;
	if (lenisNativeRafId != null) {
		try { cancelAnimationFrame(lenisNativeRafId); } catch (e1) {}
		lenisNativeRafId = null;
	}
	if (lenisCore) {
		try { lenisCore.destroy(); } catch (e) {}
		lenisCore = null;
	}
	locoScroll = null;
	window.locoScroll = null;
	if (typeof window.ScrollTrigger !== 'undefined') {
		window.ScrollTrigger.scrollerProxy(scrollRoot, {
			scrollTop: function(val) {
				if (arguments.length) window.scrollTo(0, val);
				return window.pageYOffset || scrollRoot.scrollTop;
			},
			getBoundingClientRect: function() {
				return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
			}
		});
		try { window.ScrollTrigger.refresh(); } catch (e2) {}
	}
	if (typeof $ !== 'undefined') $(window).trigger('locomotive-destroy');
	try { document.dispatchEvent(new CustomEvent('locomotive-destroy')); } catch (eD) {}
}

function initLocomotiveForViewport() {
	if (typeof Lenis === 'undefined') return;

	var scrollRoot = document.documentElement;

	try {
		lenisCore = new Lenis({
			autoRaf: false
		});
		locoScroll = createLocoCompat(lenisCore);
		window.locoScroll = locoScroll;

		if (typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined') {
			window.gsap.registerPlugin(window.ScrollTrigger);
			lenisGsapRafCb = function(time) {
				lenisCore.raf(time * 1000);
			};
			window.gsap.ticker.add(lenisGsapRafCb);
			window.gsap.ticker.lagSmoothing(0);
			window.ScrollTrigger.scrollerProxy(scrollRoot, {
				scrollTop: function(val) {
					if (arguments.length) lenisCore.scrollTo(val, { immediate: true });
					return lenisCore.scroll;
				},
				getBoundingClientRect: function() {
					return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
				}
			});
			lenisCore.on('scroll', window.ScrollTrigger.update);
		} else {
			lenisNativeRafId = requestAnimationFrame(lenisNativeRafLoop);
		}

		$(window).trigger('locomotive-ready');
		try { document.dispatchEvent(new CustomEvent('locomotive-ready')); } catch (eR) {}

		$(window).off('load.locoScrollUpdate').on('load.locoScrollUpdate', function() {
			if (locoScroll && typeof locoScroll.update === 'function') {
				locoScroll.update();
				setTimeout(function() {
					locoScroll.update();
					if (typeof window.ScrollTrigger !== 'undefined') window.ScrollTrigger.refresh();
				}, 100);
				if (document.getElementById('sticky-container_about')) {
					setTimeout(function() { locoScroll.update(); }, 300);
					setTimeout(function() { locoScroll.update(); }, 800);
				}
			}
		});
	} catch (e) {
		console.warn('Lenis init failed:', e);
	}
}

function syncLocomotiveToViewport() {
	var want = locomotiveShouldRun();
	if (want === locoViewportActive) return;
	locoViewportActive = want;
	if (want) {
		initLocomotiveForViewport();
	} else {
		destroyLocomotiveForViewport();
	}
}

$(function() {
	initDataScrollInviewPolyfill();
	syncLocomotiveToViewport();
	$(window).on('resize', function() {
		syncLocomotiveToViewport();
		if (lenisCore && typeof lenisCore.resize === 'function') lenisCore.resize();
	});
});

//---------------------------------------------------------//
// アンカーリンク（#features など）: Lenis 利用時は scrollTo で合わせる
//---------------------------------------------------------//
$(function () {
	$(document).on('click', 'a.footer__back-to-top', function (e) {
		e.preventDefault();
		if (typeof locoScroll !== 'undefined' && locoScroll && typeof locoScroll.scrollTo === 'function') {
			var topEl = document.getElementById('top') || document.documentElement;
			try {
				locoScroll.scrollTo(topEl, { duration: 900, offset: 0 });
			} catch (err) {}
		} else {
			try {
				window.scrollTo({ top: 0, behavior: 'smooth' });
			} catch (err2) {
				window.scrollTo(0, 0);
			}
		}
	});

	$(document).on('click', 'a[href*="#"]', function (e) {
		if ($(this).is('.footer__back-to-top')) return;
		/* Help FAQ カテゴリナビは sections/help-faq.liquid 側でオフセット付き scrollTo（ここで上書きしない） */
		if ($(this).is('.help-faq__category-link')) return;
		var hash = this.hash;
		if (!hash || hash.length < 2) return;

		var id = hash.slice(1);
		try {
			id = decodeURIComponent(id);
		} catch (err) {}

		var targetEl = document.getElementById(id);
		if (!targetEl) {
			targetEl = document.querySelector('[data-anchor="' + id.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]');
		}
		if (!targetEl) return;

		var locPath = window.location.pathname.replace(/\//g, '');
		var linkPath = (this.pathname || '').replace(/\//g, '');
		if (locPath !== linkPath) return;
		if (this.hostname && window.location.hostname && this.hostname !== window.location.hostname) return;

		if (typeof locoScroll === 'undefined' || !locoScroll || typeof locoScroll.scrollTo !== 'function') return;

		e.preventDefault();

		var headerOffset = 0;
		try {
			var h = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
			var parsedHeader = parseInt(h, 10);
			if (!isNaN(parsedHeader)) headerOffset = parsedHeader;
		} catch (err2) {}

		try {
			locoScroll.scrollTo(targetEl, {
				offset: headerOffset ? -headerOffset : 0,
				duration: 900
			});
		} catch (err3) {}

		if (typeof $ !== 'undefined' && $('.gnav').is(':visible')) {
			$('.menu').trigger('click');
		}
	});
});

//---------------------------------------------------------//
//fade in
//---------------------------------------------------------//
$(function(){
	$(window).on('load scroll',function (){
		$('.animation').each(function(){
			//ターゲットの位置を取得
			var target = $(this).offset().top;
			//スクロール量を取得
			var scroll = $(window).scrollTop();
			//ウィンドウの高さを取得
			var height = $(window).height();
			//ターゲットまでスクロールするとフェードインする
			if (scroll > target - height){
				//クラスを付与
				$(this).addClass('active');
			}
		});
	});
});

//---------------------------------------------------------//
//	top header scroll
//---------------------------------------------------------//
// top header scroll
// $(function() {
// 	$(window).scroll(function() {
// 		const scroll = $(window).scrollTop();
// 		const fv = $(window).height();
// 		if (scroll >= fv) { 
// 		$("header").addClass("header-color");
// 		} else {
// 		$("header").removeClass("header-color");
// 		}
// 	});
// });


// 慣性スクロール


// const lenis = new Lenis({
// 	lerp: 0.05, // 慣性の強さ
// 	smoothWheel: true,
// 	//content: anchor,
// 	//duration: 1, // スクロールアニメーションの時間
// 	//easing: easeOutQuart, // イージング関数
// });

// lenis.on('scroll', ScrollTrigger.update)

// function raf(time) {
//   lenis.raf(time);
//   requestAnimationFrame(raf);
// }
// requestAnimationFrame(raf);








//Line up random
// $(function() {
// 	var box = [];
// 	$('.c-slide1__item').each(function() {
// 			box.push($(this).html());
// 	});
// 	box.sort(function() {
// 			return Math.random() - Math.random();
// 	});
// 	$('.c-slide1__item').empty();
	
// 	var i = 0;
// 	$('.c-slide1__item').each(function() {
// 			$(this).append(box[i]);
// 			i++;
// 	});
// });




// var breakPoint1 = 767;
// var Scrollbar = window.Scrollbar;
// var ScrollbarWidth = 0;

// function spCheck() {
// return $(window).width() <= breakPoint1;
// }

$(document).ready(function () {
var $body = $('body');
var wrapperScroll = null;





$('.c-mv').each(function () {
	var $this = $(this);
	var item = $('.c-mv__item', $this);

	if (item.length >= 2) {
	var current = $('.c-mv__item.current', $this);

	if (!current.length) {
		item.eq(0).addClass('current');
	}

	setInterval(function () {
		var $hidden = $('.c-mv__item.current', $this);
		var $next = $hidden.next('.c-mv__item');

		if (!$next.length) {
		$next = item.eq(0);
		}

		item.removeClass("top-hidden");
		$hidden.removeClass("current").addClass("top-hidden");
		$next.addClass("current");
	}, 6500);
	}
});

$('.c-recycle').each(function () {
	var $this = $(this);
	var item = $('.c-recycle__item', $this);

	if (item.length >= 2) {
	var current = $('.c-recycle__item.current', $this);

	if (!current.length) {
		item.eq(0).addClass('current');
	}

	setInterval(function () {
		var $hidden = $('.c-recycle__item.current', $this);
		var $next = $hidden.next('.c-recycle__item');

		if (!$next.length) {
		$next = item.eq(0);
		}

		item.removeClass("hidden");
		$hidden.removeClass("current").addClass("hidden");
		$next.addClass("current");
	}, 6500);
	}
});



// $(function () {
// 	$(".-p0").addClass("is-current");

// 	// hoverする要素のclass名
// 	$(".-p0").hover(
// 	  function () {
// 		// hoverした時の処理(classを付与)
// 		$(".-p0").addClass("is-current");
// 	  },
// 	  function () {
// 		// hoverを外した時の処理(classを外す)
// 		$(".js-box").removeClass("js-hover");
// 	  }
// 	);
//   });












// 'use strict';

// var breakPoint1 = 767;
// var Scrollbar = window.Scrollbar;
// var ScrollbarWidth = 0;

// function spCheck() {
// 	return $(window).width() <= breakPoint1;
// }

// $(document).ready(function () {
// 	var $body = $('body');
// 	var wrapperScroll = null;

// 	function getScrollTop() {
// 	if (wrapperScroll) {
// 		return wrapperScroll.scrollTop;
// 	} else {
// 		return $(window).scrollTop();
// 	}
// 	}

// 	var htmlBodyAnimate = function htmlBodyAnimate(target) {
// 	if (wrapperScroll) {
// 		var scrollTop = 0;

// 		if (target.offset().top !== 0) {
// 		scrollTop = target.offset().top + wrapperScroll.scrollTop;
// 		}

// 		wrapperScroll.scrollTo(0, scrollTop, 800);
// 	} else {
// 		var targetPosition = target.offset().top;
// 		$('body, html').animate({
// 		scrollTop: targetPosition
// 		}, 800, 'swing');
// 	}
// 	};

// 	var loadAnchor = function loadAnchor() {
// 	var localLink = window.location + '';

// 	if (localLink.indexOf('#') !== -1) {
// 		var hash = localLink.slice(localLink.indexOf('#'));
// 		var dataAnchor = $('[data-anchor="' + hash.slice(1) + '"]');

// 		if ($(hash).length) {
// 		htmlBodyAnimate($(hash));
// 		} else if (dataAnchor.length) {
// 		htmlBodyAnimate(dataAnchor);
// 		}
// 	}
// 	};

// 	var fadeInScroll = function fadeInScroll() {
// 	$('.u-fadeIn').not('.show').each(function () {
// 		var targetTop,
// 			target = $(this);
// 		var numAdd = 50;

// 		if (wrapperScroll) {
// 		targetTop = target.offset().top + wrapperScroll.scrollTop;
// 		} else {
// 		targetTop = target.offset().top;
// 		}

// 		if (getScrollTop() > targetTop - ($(window).height() - numAdd)) {
// 		$(this).addClass('show');
// 		}
// 	});
// 	};

// 	var topMvScroll = function topMvScroll() {
// 	var mvTop = $('.c-top');

// 	if (mvTop.length) {
// 		if (getScrollTop() >= mvTop.outerHeight()) {
// 		mvTop.addClass('is-hidden');
// 		} else {
// 		mvTop.removeClass('is-hidden');
// 		}
// 	}
// 	};

// 	var topLogoScroll = function topLogoScroll() {
// 	var logo = $('body.page-top .c-header__logo');

// 	if (logo.length) {
// 		if (getScrollTop() >= $(window).height()) {
// 		logo.addClass('is-show');
// 		} else {
// 		logo.removeClass('is-show');
// 		}
// 	}
// 	};

// 	// var footerFixCheck = function footerFixCheck() {
// 	// var wrapper = $('#wrapper');
// 	// var footer = $('footer');
// 	// var main = $('main');

// 	// if (wrapper.length && footer.length && main.length) {
// 	// 	if ($(window).height() < footer.outerHeight()) {
// 	// 	main.addClass('footer-no-fixed');
// 	// 	footer.addClass('footer-no-fixed');
// 	// 	main.after(footer);
// 	// 	} else {
// 	// 	main.removeClass('footer-no-fixed');
// 	// 	footer.removeClass('footer-no-fixed');
// 	// 	footer.appendTo(wrapper);
// 	// 	}
// 	// }
// 	// };

// 	var baseWidth = function baseWidth() {
// 	var base = $('.js-base-width');

// 	if (base.length) {
// 		base.css('left', $(window).scrollLeft() * -1);
// 	}
// 	};

// 	$('#headerNavBar').on('click', function () {
// 	var menu = $('#headerNavMenu');

// 	if (menu.length) {
// 		$(this).toggleClass('open');
// 		$('header').toggleClass('open');
// 		$('body').toggleClass('header-open');
// 		menu.toggleClass('open');
// 	}
// 	});
// 	$('.c-mv').each(function () {
// 	var $this = $(this);
// 	var item = $('.c-mv__item', $this);

// 	if (item.length >= 2) {
// 		var current = $('.c-mv__item.current', $this);

// 		if (!current.length) {
// 		item.eq(0).addClass('current');
// 		}

// 		setInterval(function () {
// 		var $hidden = $('.c-mv__item.current', $this);
// 		var $next = $hidden.next('.c-mv__item');

// 		if (!$next.length) {
// 			$next = item.eq(0);
// 		}

// 		item.removeClass("hidden");
// 		$hidden.removeClass("current").addClass("hidden");
// 		$next.addClass("current");
// 		}, 6500);
// 	}
// 	});
// 	/* スムーズスクロール
// 	/*---------------------------------------------------------*/

// 	// $(document).on('click', 'a[href*="#"]', function (e) {
// 	// var hash = this.hash;
// 	// var target = $(hash === '#' || hash === '' ? 'html' : hash);

// 	// if (target.length === 0) {
// 	// 	target = $('[data-anchor="' + hash.slice(1) + '"]');
// 	// }

// 	// var locationPath = window.location.pathname.replace(/\//g, '');
// 	// var thisPath = this.pathname.replace(/\//g, '');

// 	// if (target.length && locationPath === thisPath) {
// 	// 	e.preventDefault();

// 	// 	var scrollStop = function scrollStop() {
// 	// 	$('body, html').stop(true);
// 	// 	};

// 	// 	if ($(this).parents('.c-header__collapse').length) {
// 	// 	$('.c-header__navbar.open').trigger('click');
// 	// 	setTimeout(function () {
// 	// 		htmlBodyAnimate(target);
// 	// 	}, 300);
// 	// 	} else {
// 	// 	htmlBodyAnimate(target);
// 	// 	}

// 	// 	window.addEventListener('DOMMouseScroll', scrollStop, false);
// 	// 	window.onmousewheel = document.onmousewheel = scrollStop;
// 	// }
// 	// });
// 	$('.c-slide1').each(function () {
// 	Scrollbar.init(this, {}); 
// 	//  $(this).slick({
// 	// 	dots: false,
// 	// 	arrow: true,
// 	// 	infinite: false,
// 	// 	slidesToShow: 5,
// 	// 	slidesToScroll: 1,
// 	// 	slidesPerView: 1.23,
// 	// 	swipeToSlide: true,
// 	// 	useTransform: false,
// 	// 	speed: 400,
// 	// 	responsive: [
// 	// 		{
// 	// 			breakpoint: 767,
// 	// 			settings: {
// 	// 				slidesToShow: 1,
// 	// 				slidesToScroll: 1,
// 	// 			}
// 	// 		}
// 	// 	]
// 	// });
// 	});
// 	$('.c-slide2').each(function () {
// 	var $this = $(this);
// 	var swiper = new Swiper(this, {
// 		direction: 'horizontal',
// 		slidesPerView: 1,
// 		spaceBetween: 0,
// 		watchOverflow: true,
// 		freeMode: false,
// 		loop: false,
// 		navigation: {
// 		nextEl: '.swiper-button-next',
// 		prevEl: '.swiper-button-prev'
// 		},
// 		scrollbar: {
// 		el: '.swiper-scrollbar',
// 		draggable: true //dragSize: 50

// 		}
// 	}); //Scrollbar.init(this, {});
// 	// let slide2 = $(this).slick({
// 	// 	dots: true,
// 	// 	arrow: true,
// 	// 	infinite: false,
// 	// 	slidesToShow: 1,
// 	// 	slidesToScroll: 1,
// 	// 	swipeToSlide: false,
// 	// 	useTransform: false,
// 	// 	edgeFriction: 0,
// 	// 	speed: 400,
// 	// }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
// 	// 	let dots = $('.slick-dots', slide2);
// 	// 	if (dots.length) {dots.addClass('show');}
// 	// 	let dot = $('.slick-dots li:first-child', slide2);
// 	// 	if (dot.length) {
// 	// 		let calc = ((nextSlide) / (slick.slideCount - 1)) * 100;
// 	// 		let width = dot.outerWidth();
// 	// 		let add = width / 2;
// 	// 		if (calc === 0) {
// 	// 			add = 0;
// 	// 		} else if (calc === 100) {
// 	// 			add = width;
// 	// 		}
// 	// 		dot.css("left", 'calc(' + calc + '% - ' + add + 'px)');
// 	// 	}
// 	// });
// 	//
// 	// $(this).on('touchstart', function () {
// 	// 	$(this).addClass('touchstart');
// 	// 	let dots = $('.slick-dots', slide2);
// 	// 	if (dots.length) {dots.addClass('show');}
// 	// });
// 	});
// 	$('.c-slide3').each(function () {
// 	Scrollbar.init(this, {}); // $(this).slick({
// 	// 	dots: false,
// 	// 	arrow: true,
// 	// 	infinite: false,
// 	// 	slidesToShow: 4,
// 	// 	slidesToScroll: 1,
// 	// 	adaptiveHeight: true,
// 	// 	useTransform: false,
// 	// 	swipeToSlide: true,
// 	// 	speed: 400,
// 	// 	responsive: [
// 	// 		{
// 	// 			breakpoint: 767,
// 	// 			settings: {
// 	// 				slidesToShow: 2,
// 	// 				slidesToScroll: 1,
// 	// 			}
// 	// 		}
// 	// 	]
// 	// });
// 	});

// 	(function () {
// 	var box2map = $('.c-box2__map');

// 	if (box2map.length) {
// 		box2map.click(function () {
// 		$(this).find('iframe').addClass('clicked');
// 		}).mouseleave(function () {
// 		$(this).find('iframe').removeClass('clicked');
// 		});
// 	}
// 	})();

// 	(function () {
// 	var div = document.createElement('div');
// 	div.style.setProperty('display', 'none');
// 	div.style.setProperty('width', '100vw');
// 	$(div).appendTo($('body'));
// 	var style = document.createElement('style');
// 	document.getElementsByTagName("head")[0].appendChild(style);

// 	var updateScrollBar = function updateScrollBar() {

// 		var wrapperBody = $('#wrapper-body');

// 		if (wrapper.length && wrapperBody.length) {
// 		var footerHeight = $('footer').outerHeight();
// 		wrapper.css('margin-bottom', footerHeight);
// 		wrapperBody.css('min-height', $(window).height() - footerHeight);
// 		}

// 		var barWidth = Math.round($(div).width() - $(window).width());
// 		style.innerHTML = ':root {--scroll-bar-width: ' + barWidth + 'px}';
// 		ScrollbarWidth = barWidth - 400;
// 	};

// 	if (typeof ResizeObserver === 'function') {
// 		var resizeObserver = new ResizeObserver(function () {
// 		updateScrollBar();
// 		});
// 		resizeObserver.observe(document.getElementsByTagName("BODY")[0]);
// 	}

// 	window.addEventListener("resize", updateScrollBar);
// 	window.addEventListener("load", updateScrollBar);
// 	updateScrollBar();
// 	})();

// 	if ($body.hasClass('is-scrollbar')) {
// 	if (ScrollbarWidth > 1) {
// 		$body.addClass('js-scrollbar');
// 		wrapperScroll = Scrollbar.init(document.getElementById('wrapper-scroll'), {
// 		damping: 0.04,
// 		delegateTo: document.getElementsByTagName("BODY")[0]
// 		});
// 		wrapperScroll.addListener(function () {
// 		fadeInScroll();
// 		topLogoScroll();
// 		topMvScroll();
// 		baseWidth();
// 		});
// 	}
// 	}

// 	// footerFixCheck();
// 	fadeInScroll();
// 	topLogoScroll();
// 	topMvScroll();
// 	baseWidth();
// 	$(window).on('resize', function () {
// 	topMvScroll();
// 	baseWidth();
// 	}).on('scroll', function () {
// 	fadeInScroll();
// 	topLogoScroll();
// 	topMvScroll();
// 	baseWidth();
// 	}).on('load', function () {
// 	footerFixCheck();
// 	loadAnchor();
// 	baseWidth();
// 	});
// 	$body.addClass('loaded');
// });





// $body.addClass('loaded');
});